<template>
    <l-layout :layout="['xs12']">
      <v-card class="pa-2">
        <v-layout column justify-center>
          <v-layout>
            <v-flex xs6>
              <l-autocomplete
                label="搜索用户"
                :get-data="findUsers"
                item-text="name"
                item-sub-text="loginId"
                prepend-icon="$vuetify.icons.person"
                v-model="user"
              ></l-autocomplete>
            </v-flex>
            <v-flex xs4>
              <v-select :items="typeSelect" v-model="type" item-text="name" item-value="val" prepend-icon="$vuetify.icons.code"
                        label="预约类型选择" chips></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-btn flat color="primary" @click="goToFinConfigDetail">查看预约最终配置</v-btn>
          </v-layout>
        </v-layout>
      </v-card>
    </l-layout>
</template>

<script>
    export default {
        name: "searchReservationConfig",
        data(){
          return {
            user:'',
            typeSelect:[
              {name:'个人预约',val:'order_object'},
              {name:'单位预约',val:'order_group'}
            ],
            paramTypeSelect:[
              {name:'姓名',value:'name'},
              {name:'学号',value:'loginId'}
            ],
            type:'order_object',
            paramType:'loginId'
          }
        },
        methods:{
          async findUsers (searchValue) {
            let pagination = {
              pages:1,
              rowsPerPage:100
            }
            let nameItems = []
            let loginIdItems = []
            let {items:items1} = await this.$store.dispatch('userAdmin/getUsers',{pagination:pagination,search:{key:'name',value:searchValue}})
            let {items:items2} = await this.$store.dispatch('userAdmin/getUsers',{pagination:pagination,search:{key:'loginId',value:searchValue}})
            nameItems = items1
            loginIdItems = items2
            if(nameItems.length!==0){
              return nameItems
            }else{
              return loginIdItems
            }
          },
          goToFinConfigDetail(){
            if(this.user===""||!this.user){
              this.$L.alert('error',{message:'请先选择用户'})
              return
            }
            this.$router.push({
              name: 'ConfigDetail',
              query: {
                ownerId: this.user.id,
                orderType: "order_object",
                status: 'readonly',
                ownerType: 'object',
                aim:'final',
                configType:this.type
              }
            })
          }
        }
    }
</script>

<style scoped>

</style>
